import homePageImage from "../img/home_page_image.png";
import { HeaderSmall, Padding } from "./text_display/main_content_text_styling";
import { Bold } from "./themes and styles/text_styles";
import { ColumnGrid } from "./divider and frames/layouts";
import { LoginFormMinimal } from "./forms/login_form";
import styled, { css } from "styled-components";
import { useAuth } from "../authentication/auth_provider";
import { HowCreateAccount } from "./faq/faq";

const intro_text = "Die Hamburg City Health Study (HCHS) ist eine prospektive bevölkerungsbasierte Langzeit-Kohortenstudie, die seit 2016 am Universitätsklinikum Hamburg-Eppendorf (UKE) durchgeführt wird. Sie basiert auf einer Zufallsstichprobe von Hamburger:innen im Alter von 45 bis 75 Jahren. Ziel der Studie ist es, Risikofaktoren für die häufigsten Volkskrankheiten wie Herzinfarkt, Schlaganfall, Krebs, Demenz und Depressionen zu identifizieren, um für die Zukunft bessere Behandlungs- und Präventionsmaßnahmen zu entwickeln. Über 30 Kliniken und Institute des UKE arbeiten hierfür gemeinsam an der HCHS."

const Image = styled.img`
  max-width: "100%";
  max-height: "100%";
  object-fit: "contain";

`

export function HomePage(props) {
  const { logged_in } = useAuth();

  return (
    <>
      <Image
        src={homePageImage}
        alt="HCHS sculpture installation"
      />
      <Padding>
        <div>
          {
            (!logged_in &&
              <div style={
                {
                  float: "right",
                  marginBottom: "1rem"
                }
              }>
                <LoginFormMinimal />
              </div>)
          }
          <div>
            <p>
              {intro_text}
            </p>
            <HeaderSmall text={"Willkommen auf dem HCHS-Webportal!"} />

            Entdecken Sie alles Wichtige zur HCHS-Studie:
            <ul style={{ listStyleType: "disc" }}>
              <li><Bold>Umfassender Studienüberblick -</Bold> Erfahren Sie mehr über die Ziele, den Ablauf und die Beteiligten der HCHS.</li>
              <li><Bold>Schnelle Variablen-Recherche -</Bold> Finden Sie gezielt die für Sie relevanten Variablen in unseren Variablenmanuals.</li>
              <li><Bold>Einfacher Antragsprozess -</Bold> Stellen Sie Ihren Nutzungsantrag online und wählen Sie bequem die benötigten Variablen aus</li>
            </ul>
          </div>
          <HowCreateAccount />
        </div>
      </Padding>
    </>
  )
}
